import {MAX_CV_SIZE, TRANSPORT_TYPES} from "../../constants/jobOffer";

const Spinner = () => import("@/components/Spinner/Spinner.vue");
const GoogleMap = () => import("@/components/GoogleMap/GoogleMap.vue");
const Datepicker = () => import("vuejs-datepicker/dist/vuejs-datepicker");

import { mapActions, mapGetters } from "vuex";
import profileCandidateService from "@/services/profileCandidate";
import inscriptionService from "@/services/inscription";
import jobofferService from "@/services/jobOffer";
import employService from "@/services/employ";
import generalSettingService from "@/services/generalSetting";
import { fr } from "vuejs-datepicker/dist/locale";
import validateSMS from "@/mixins/validateSMS";
import getProfileDictionary from "@/mixins/getProfileDictionary";
import Utils from "@/mixins/Utils";
import dateMixin from "@/mixins/date";

import "vue-croppa/dist/vue-croppa.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import PhoneInput                            from "@/components/Common/PhoneInput";
import { SIGN_UP_ERROR, IN_PROGRESS_STATUS, CIVILITE } from "../../constants/inscription";
import moment                                from "moment";
import uploadFile                            from "../../mixins/uploadFile";
import {FILE_ERROR}                          from "../../constants/variables";

export default {
  components: {
    Spinner,
    GoogleMap,
    Datepicker,
    PhoneInput,
  },
  name: "form-registration",
  mixins: [validateSMS, getProfileDictionary, Utils, dateMixin, uploadFile],
  data: () => ({
    loadingMission: true,
    isConfirmedCodeSuccess: false,
    isVerifiedPhoneNumber: false,
    isDirtyPhone: false,
    fr: fr,
    user: {
      meansTransportCar: false,
      meansTransportMoto: false,
      meansTransportBike: false,
      meansTransportPermisB: false,
      meansTransportPublicTransport: false,
      emailConfirmation: null,
      email: null,
      lastName: null,
      firstName: null,
      phone: null,
      address: "",
      zipcode: "",
      city: "",
      latitude: null,
      longitude: null,
      civilite: CIVILITE.MONSIEUR,
      experiences: [
        {
          startDate: "",
          endDate: "",
          title: "",
          mission: "",
          pkIxAdvExperienceType: 0,
          employer: "",
        },
      ],
      formations: [{
        diplomaYear: "",
        diplomaTitle: ""
      }],
      confirmationSMSCode: null,
      pkJobOffer: null,
      typesTransports: [],
      cvFile: null
    },
    emptyExperience: {
      startDate: "",
      endDate: "",
      title: "",
      mission: "",
      pkIxAdvExperienceType: 0,
      employer: "",
    },
    formation: {
      diplomaYear: "",
      diplomaTitle: "",
    },
    experienceList: [{
      startDate: {
        month: null,
        year: null,
        error: false
      },
      endDate: {
        month: null,
        year: null,
        error: false
      }
    }],
    showAlert: false,
    submitted: false,
    alert: {},
    isEmailExist: false,
    isPhoneExist: false,
    transportTypesConst: null,
    candidateUid: null,
    candidateId: null,
    isCreated: false,
    jobOffer: null,
    maxSizeUploadFile: 0,
    configuration: null
  }),
  created() {

    if (this.uid) {
      this.getCandidateInfo();
    }
    if (this.jobOfferId) {
      this.loadJobOffer();
    } else {
      this.loadingMission = false;
    }
    if (this.locality) {
      this.$gmapApiPromiseLazy().then(() => {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: this.locality }, (results, status) => {
          if (status === "OK") {
            this.setAddress(results[0]);
          }
        });
      })
    }
    this.getGeneralSetting();
    this.getProfileTypes();
    this.getCountries();
    // this.getTransportTypes();
  },
  computed: {
    ...mapGetters('auth', {
      generalSetting : 'generalSetting'
    }),
    ...mapGetters("recruitment", ['transportTypes']),
    phoneNumber() {
      return this.user.phone;
    },
    email() {
      return this.user.email;
    },
    uid() {
      return this.$route.query.uid || null;
    },
    jobOfferId() {
      return this.$route.query.id || null;
    },
    locality() {
      return this.$route.query.locality;
    },
    lat() {
      return this.$route.query.lat;
    },
    lng() {
      return this.$route.query.lng;
    },
    monthList() {
      return [
        {
          value: null,
          text: this.$t('month-label'),
          disabled: true
        },
        ...moment.months().map(month => {
          return {
            value: moment().month(month).format('MM'),
            text: this.$options.filters.capitalize(month)
          }
        })
      ]
    },
    yearList() {
      return [
      {
        value: null,
        text: this.$t('year-label'),
        disabled: true
      },
        ...this.getYearArray(1970)
      ];
    },
    bodyParams() {
      const body = JSON.parse(JSON.stringify(this.user));
      body['formations'] = body['formations'].map((format, i) => {
        return {
          diplomaTitle: format.diplomaTitle,
          diplomayear: format.diplomaYear
        }
      });
      Object.keys(this.transportType).forEach(key => {
        delete body[key];
      });
      Object.keys(body).forEach(key => {
        if (!body[key]) {
          delete body[key];
        }
      });

      body.experiences.forEach((exp, i) => {
        delete exp.pkAdv;
        body.experiences[i] = {
          ...exp,
          startDate: new Date(exp.startDate).getTime(),
          endDate: new Date(new Date(exp.endDate).getFullYear(), (new Date(exp.endDate).getMonth())+1,0).getTime(),
        }
      });
      body['pkCivility'] = this.user.civilite;
      body['pkJobOffer'] = this.jobOfferId || null;
      delete body['pkIxCountriesIso3166'];
      delete body['emailConfirmation'];
      return body;
    },
    transportType() {
      return TRANSPORT_TYPES;
    },
    isEmptyExp() {
      return this.user.experiences.length === 1 &&
      !this.user.experiences[0].endDate &&
      !this.user.experiences[0].startDate &&
      !this.user.experiences[0].employer &&
      !this.user.experiences[0].title &&
      !this.user.experiences[0].mission;
    },
    isValidExperience() {
      let isValidExp = true;
      !this.isEmptyExp && this.user.experiences.forEach((element) => {
        if (
          !element.endDate ||
          !element.startDate ||
          !element.employer ||
          !element.title
        ) {
          isValidExp = false;
        }
      });
      return isValidExp;
    },
    isEmptyFormation() {
      return this.user.formations.length === 1 &&
      !this.user.formations[0].diplomaYear &&
      !this.user.formations[0].diplomaTitle

    },
    isValidFormation() {
      let isValidFormation = true;
      !this.isEmptyFormation && this.user.formations.forEach((element) => {
        if (
          !element.diplomaYear ||
          !element.diplomaTitle
        ) {
          isValidFormation = false;
        }
      });
      return isValidFormation;
    },
    civilite() {
      return CIVILITE;
    }
  },
  watch: {
    phoneNumber() {
      if (this.isPhoneExist) {
        this.isPhoneExist = false;
        this.alert = {};
      }
    },
    email() {
      if (this.isEmailExist) {
        this.isEmailExist = false;
        this.alert = {};
      }
    },
    jobOfferId() {
      this.$router.go()
    },
    generalSetting : {
      immediate: true,
      handler(value) {
        if(value && value.redirectPageToApply) {
          window.location.replace(value.redirectPageToApply)
  
        }
      }
    }
  },
  methods: {
    ...mapActions("auth", {
      loginManually: "LOGIN_MANUALLY",
    }),
    ...mapActions("recruitment", {
      fetchTransportType: 'getTransportTypes'
    }),
    loadJobOffer() {
      jobofferService
        .getJobOffer(this.jobOfferId)
        .then((res) => {
          if (res.success) {
            this.jobOffer = res.data;
          } else {
            this.$router.push({ name: 'sign-up' })
          }
          this.loadingMission = false;
        })
        .catch((err) => {
          vue.callToaster(vue.$t('problem-arise'));
          this.$router.push({ name: 'sign-up' })
          this.loadingMission = false;
        });
    },
    getGeneralSetting() {
      generalSettingService.getGeneralSetting().then((res) => {
        if(res.success && res.configuration) {
          this.configuration = res.configuration;
          this.maxSizeUploadFile = this.configuration.maxSizeUploadFile;
        }
      })
    },

    sendLogin() {
      const body = {
        message: this.$t('verify-sms-content')
      }
      inscriptionService.sendLogin(this.user.phone, body).then(res => {
        if (res.success) {
          this.$bvModal.msgBoxOk(
            this.$t('verify-phone-success'), {
            title: this.$t('verify-phone-title'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'primary',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true
          });
        }
      });
    },

    setAddress(place) {
      if (place.formatted_address) {
        let route,
          postal_code,
          locality,
          street_number = "";
        postal_code = place.address_components.find(component => component.types.includes("postal_code"));
        route = place.address_components.find(component => component.types.includes("route"));
        locality = place.address_components.find(component => component.types.includes("locality") || component.types.includes('administrative_area_level_1'));
        street_number = place.address_components.find(component => component.types.includes("street_number"));

        this.user.address = !street_number || !route ? place.formatted_address : (street_number.long_name + ' ' + route.long_name);
        this.user.zipcode = postal_code ? postal_code.long_name : '';
        this.user.city = locality? locality.long_name : '';
        this.user.latitude = place.geometry.location.lat();
        this.user.longitude = place.geometry.location.lng();
      }
    },
    changeAddress($event) {
      const value = $event.target.value;

      if(value === '') {
        this.user.address = '';
        this.user.zipcode = '';
        this.user.city = '';
      }
    },
    validateBeforeSubmit() {
      const vue = this;
      this.$validator.validateAll().then((result) => {
        let validError = false;

        this.user.formations.forEach((element) => {
          if (
            !/^([0-9]{4})$/.test(element.diplomaYear) &&
            element.diplomaYear != ''
          ) {
            validError = true;
            this.callToaster(this.$t("year-format-yyyy"));
          }
        });

        if (!this.isValidExperience) {
          this.callToaster(vue.$t("fill-all-experience-field"));
          return;
        }

        if (!this.isValidFormation) {
          this.callToaster(this.$t('empty-information'));
          return;
        }

        if (result && !validError && !this.isEmailExist && this.isValidFormation) {
          this.user.meansTransportCar = !!this.user.meansTransportCar;
          this.user.meansTransportMoto = !!this.user.meansTransportMoto;
          this.user.meansTransportBike = !!this.user.meansTransportBike;
          this.user.meansTransportPermisB = !!this.user.meansTransportPermisB;
          this.user.meansTransportPublicTransport = !!this.user.meansTransportPublicTransport;

          vue.submitted = true;
          const commonErrorHandler = () => {
            this.alert.show = true;
            this.submitted = false;
            this.alert.variant = "danger";
          };
          jobofferService
            .submitCandidate(this.candidateUid, this.bodyParams)
            .then((response) => {
              // handle success
              if (response.success) {
                this.$bvModal.msgBoxOk(
                  this.$t('send-my-candidature-success'),
                  {
                    size: 'sm',
                    centered: true,
                    okTitle: this.$t('adv-close-btn')
                  }).then(res => {
                    window.location.replace(this.configuration.testimonialsRedirection);
                  })
              } else if (response.data.fieldError === SIGN_UP_ERROR.EXIST_PHONE) {
                this.isPhoneExist = true;
                commonErrorHandler();
                this.alert.message = `
                  ${this.$t('inscription-phone-exist-already')}
                  <span class="high-light-link" id="confirm-exist-phone">${this.$t('inscription-send-email-by-sms')}</span>
                `;
                setTimeout(() => {
                  document.getElementById('confirm-exist-phone').onclick= () => {
                    this.showConfirmation('phone');
                  }
                }, 1000);
              } else if (response.data.fieldError === SIGN_UP_ERROR.EXIST_EMAIL) {
                this.handleEmailError();
              } else {
                commonErrorHandler();
                vue.alert.message = response.message;
              }
            })
            .catch(function(error) {
              // handle error
              vue.showAlert = true;
              vue.submitted = false;
              vue.message = `${vue.$t("error-occur")}: ${error}`;
            });

          return;
        }

        this.showAlert = true;
        this.message = this.$t("some-field-not-validate");
        return;
      });
    },

    handleEmailError() {
      this.isEmailExist = true;
      this.alert.show = true;
      this.submitted = false;
      this.alert.variant = "danger";
      this.alert.message = `
                  ${this.$t("inscription-email-exist-already")}
                  <span class="high-light-link" id="confirm-exist-email">${this.$t('inscription-link-to-forgot-password')}</span>`;

      setTimeout(() => {
        document.getElementById('confirm-exist-email').onclick = () => {
          this.showConfirmation('email');
        }
      }, 1000);
    },

    showConfirmation(type) {
      const confirmMessage = type === 'email'?
        this.$t('inscription-exist-email-confirmation') :
        this.$t('inscription-exist-phone-confirmation')
      this.$bvModal.msgBoxConfirm(
        confirmMessage, {
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: 'Oui',
          cancelTitle: 'Non',
          hideHeaderClose: false,
          centered: true
        }).then(res => {
        if (res) {
          if (type === 'email') {
            this.goToForgotPwd();
          } else if (type === 'phone') {
            this.sendLogin();
          }
        }
      });
    },
    goToForgotPwd() {
      this.$router.push({
        name: 'login',
        query: {
          email: this.user.email,
          forgotPwd: true
        }
      });
    },
    addExperience(index) {
      const {startDate, endDate, title, mission, employer} = this.user.experiences[index];
      const newExpObject = {
        startDate: {
          month: null,
          year: null,
          error: false
        },
        endDate: {
          month: null,
          year: null,
          error: false
        }
      }
      if (
          !startDate ||
          !endDate ||
          !title ||
          !employer
      ) {
        this.callToaster(this.$t('apply-candidate-experience-alert'));
        return;
      }
      this.user.experiences.push(Object.assign({}, this.emptyExperience));
      this.experienceList.push(newExpObject);
    },
    deleteExperience(i) {
      this.user.experiences.splice(i, 1);
      this.experienceList.splice(i, 1);
      if (this.user.experiences.length <= 0) {
        this.user.experiences.push(Object.assign({}, this.emptyExperience));
      }
      this.updateData();
    },
    addFormation(i) {
      if (
        this.user.formations[i].diplomaYear === "" ||
        this.user.formations[i].diplomaTitle === "" ||
          this.errors.has('formation-date-edit')
      ) {
        this.callToaster(this.$t('empty-information'));
        return;
      }

      this.user.formations.push(this.formation);
      this.formation = {
        diplomaYear: "",
        diplomaTitle: ""
      };
    },
    deleteFormation(i) {
      this.user.formations.splice(i, 1);
      this.updateData();
    },
    validatePhone(ref) {
      if (this.veeFields[ref] && this.veeFields[ref].dirty) {
        this.isDirtyPhone = this.veeFields[ref].dirty;
      }
    },

    updateData() {
      this.convertTransport();
      if (!this.isCreated) {
        if (!this.uid) {
          !this.isEmailExist && this.addNewCandidate();
        } else {
          this.isCreated = true;
          this.candidateUid = this.uid;
          this.updateCandidate();
        }
      } else {
        this.candidateUid && this.updateCandidate();
      }
    },

    addNewCandidate() {
      if (!this.errors.has('confirmer votre email')
        && !this.errors.has('votre email')
        && this.user.email
        && this.user.emailConfirmation) {
        this.isCreated = true;
        jobofferService.createCandidate(this.bodyParams).then(res => {
          if (res.success) {
            this.candidateUid = res.data.UID;
            this.candidateId = res.data.IDCandidature;
          } else {
            this.isCreated = false;
            if (res.message.includes('email')) {
              this.handleEmailError();
            }
          }
        }).catch(err => {
          this.isCreated = false;
          this.callToaster(err.message);
        })
      }
    },

    updateCandidate() {
      jobofferService.updateCandidate(this.candidateUid, this.bodyParams);
    },
    getCandidateInfo() {
      const alert = (message) => {
        this.$bvModal.msgBoxConfirm(message, {
          okTitle: this.$t('yes'),
          cancelTitle: this.$t('no'),
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(res => {
          if (!res) {
            this.goHome();
          } else {
            this.$router.replace({ query: {} });
          }
        })
      };
      jobofferService.getCandidateByUid(this.uid).then(res => {
        if (res.success) {
          if (res.data.idStatus === IN_PROGRESS_STATUS) {
            this.fullFillExistCandidate(res);
          } else {
            alert(this.$t('send-my-candidature-invalid-status-question'));
          }
        } else {
          alert(this.$t('send-my-candidature-not-exist-question'));
        }
      })
    },

    fullFillExistCandidate(res) {
      this.candidateUid = this.uid;
      Object.keys(this.user).forEach(key => {
        if (res.data[key]) {
          this.user[key] = res.data[key];
        }
        switch (key) {
          case 'experiences':
            this.user.experiences.forEach((exp, i) => {
              exp.startDate = new Date(res.data.experiences[i].startDate);
              exp.endDate = new Date(res.data.experiences[i].endDate);
            });
            if (!this.user.experiences.length) {
              this.user.experiences =  [
                this.emptyExperience
              ]
            }
            break;
          case 'formations':
            if (!this.user.formations.length) {
              this.user.formations =  [
                {
                  diplomaYear: "",
                  diplomaTitle: ""
                },
              ]
            }
            break;
          case 'email':
            this.user.emailConfirmation = res.data[key];
            break;
          case 'typesTransports':
            const transportIds = res.data.typesTransports.map(type => type.pkIxTypesTransport);

            Object.keys(this.transportType).forEach(_key => {
              this.user[_key] = transportIds.includes(this.transportType[_key].value);
            });

            break;
        }
      });
    },

    convertTransport() {
      this.user.typesTransports = [];
      Object.keys(this.user).forEach(key => {
        const isAdded = this.transportType[key] && (this.user.typesTransports.find(transport => transport.pkIxTypesTransport === this.transportType[key].value));
        if (this.transportType[key] && this.user[key] && !isAdded) {
          this.user.typesTransports.push({
            pkIxTypesTransport: this.transportType[key].value
          })
        }
      })
    },

    isAddFormationBtnShown(index) {
      return index === (this.user.formations.length -1);
    },

    isAddExperienceBtnShown(index) {
      return index === (this.user.experiences.length -1);
    },

    uploadCV(event) {
      const size = event.size / 1024 / 1024;
      if(size <= this.maxSizeUploadFile) {
        this.uploadFile(event, ['pdf'], MAX_CV_SIZE).then(reader => {
          reader.readAsDataURL(event);
          setTimeout(() => {
            this.user.cvFile = reader.result;
            this.updateData();
          }, 200)
        }).catch(err => {
          this.$refs['cv'].reset();
          if (err === FILE_ERROR.MAX_SIZE) {
            this.callToaster(this.$t('upload-file-max-size-alert').replace('[fileSize]', this.maxSizeUploadFile));
          }
          if (err === FILE_ERROR.INVALID_MIME) {
            this.callToaster(this.$t('apply-candidate-cv-invalid-file'));
          }
        });
      } else {
        this.$refs['cv'].reset();
        this.callToaster(this.$t('upload-file-max-size-alert').replace('[fileSize]', this.maxSizeUploadFile));
      }
    },

    goHome() {
      this.$router.push({ path: "/public/default" });
    },
    genderChanged() {
        if (!this.candidateUid) {
          setTimeout(() => {
            this.updateData();
          }, 2000);
        } else {
          this.updateData();
        }
      },

    /**
     *
     * @param dateType (startDate or endDate)
     * @param type (month or year)
     * @param index
     */
    selectExpTime(dateType, type, index) {
      const {month, year} = this.experienceList[index][dateType];
      this.experienceList[index][dateType].error = true;
      if (month && year) {
        this.experienceList[index][dateType].error = false;
        this.user.experiences[index][dateType] = new Date(`${month}/01/${year}`).getTime();
        this.updateData();
      }
    },

    clearDate(index, dateType) {
      this.experienceList[index][dateType].month = null;
      this.experienceList[index][dateType].year = null;
      this.experienceList[index][dateType].error = false;
      this.user.experiences[index][dateType] = ''
    }
  },
};
